import { useAppSelector } from 'hooks/useRedux'
import {
  defaultFilterTypes,
  FilterableEntity,
  filterConfig,
  FilterConfigAndAvailableValues
} from 'utils/filters'

export default function useFilterConfiguration(
  attributeFilters?: FilterConfigAndAvailableValues[] | null,
  availableFilters?: FilterableEntity[]
) {
  const orgUsersById = useAppSelector(({ orgUsersById }) => orgUsersById.users)
  const supportedFilters = availableFilters || defaultFilterTypes

  const accountOwnerValues = Object.entries(orgUsersById)
    .filter(([, user]) => user?.status === 'ENABLED' && !user.bot && (user.name || user.email))
    .map(([id, user]) => ({ value: id, label: user?.name || user?.email || 'User' }))
    .sort((a, b) => a.label.localeCompare(b.label))
  accountOwnerValues.unshift({ value: '<userId>', label: 'Current User' })

  return [...filterConfig, ...(attributeFilters || [])]
    .filter(item => supportedFilters?.includes(item.filterType))
    .map(item => {
      if (
        item.filterType === FilterableEntity.ACCOUNT_OWNERS ||
        item.attributeType === 'TEAMMEMBER'
      ) {
        return { ...item, values: accountOwnerValues }
      }
      return item
    })
}
